import React, { useEffect, useState } from 'react';
import Header from '../common/Header'
import Footer from '../common/Footer'
import '../style/products/common.css'
import logo from '../img/quanto_light.webp'

// checkmark circle icon
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function QuantoRetailERP() {
    const [activeTab, setActiveTab] = useState("features");
    const [animateItems, setAnimateItems] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(0);

    const features = [
        "Comprehensive Inventory Management",
        "Sales and Billing Management",
        "Customer Relationship Management (CRM)",
        "Multi-Channel Integration",
        "Advanced Analytics and Reporting",
        "GST Compliance",
        "Role-Based Access Control",
        "Mobile Accessibility",
    ];

    const featuresDetails = [
        "Track stock levels in real time, manage replenishment, and optimize inventory turnover to reduce costs and improve efficiency.",
        "Simplify sales transactions with fast billing processes, customizable invoicing, and integrated payment solutions.",
        "Build lasting relationships with customers through targeted marketing, loyalty programs, and personalized communication.",
        "Seamlessly connect your online and offline sales channels for consistent customer experiences and centralized management.",
        "Leverage data-driven insights with customizable reports on sales, inventory, and customer behavior to make informed decisions.",
        "Stay compliant with automated GST invoicing, e-way billing, and reporting features, ensuring smooth tax compliance.",
        "Ensure data security and integrity by assigning access levels based on user roles within the organization.",
        "Access your retail operations from anywhere with mobile-friendly features, enabling management on the go.",
    ];

    const benefits = [
        "Increased Operational Efficiency",
        "Improved Customer Satisfaction",
        "Enhanced Decision-Making",
        "Cost Savings",
        "Scalability",
        "Improved Inventory Visibility",
        "Improved Customer Engagement",
        "Effective Sales Promotions"
    ];

    const benefitsDetails = [
        "Streamline workflows and reduce manual tasks, freeing up time for more strategic activities.",
        "Deliver exceptional service with faster transactions, accurate inventory, and personalized experiences.",
        "Utilize advanced analytics to gain insights into performance metrics and market trends, facilitating strategic planning.",
        "Optimize inventory management and reduce overhead costs through efficient operations and accurate forecasting.",
        "Grow your retail business with a flexible ERP solution that adapts to your changing needs.",
        "Gain full transparency into stock levels, ensuring optimal inventory availability and preventing overstocking or shortages.",
        "CRM tools help track interactions, personalize experiences, and boost customer retention, driving stronger relationships and repeat business.",
        "Easily create, manage, and track sales promotion schemes to attract customers, boost sales, and enhance brand loyalty."
    ];
    useEffect(() => {
        setAnimateItems(true);
        setSelectedPoint(0);
        const timer = setTimeout(() => setAnimateItems(false), 1800);
        return () => clearTimeout(timer);
    }, [activeTab]);

    const items = activeTab === "features" ? features : benefits;
    const details = activeTab === "features" ? featuresDetails : benefitsDetails;

    const handlePointClick = (index) => {
        setSelectedPoint(index);
    };

    // useEffect(() => {
    //     const button = document.querySelector('button');
    //     button.addEventListener('mouseover', () => {
    //         button.style.backgroundColor = '#b96d00';
    //         button.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(-2px)';
    //     });
    //     button.addEventListener('mouseout', () => {
    //         button.style.backgroundColor = 'transparent';
    //         button.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
    //         button.style.transform = 'translateY(0)';
    //     });
    // }, []);

    return (
        <>
            <Header />
            <section className="about-title-section">
                <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />Retail ERP</h2>
            </section>
            <div style={styles.container} className='products-container'>
                <header style={styles.header}>
                    <h1 style={styles.titleInfo} className='products-section-title'>Quanto Retail ERP: Your Complete Retail Management Solution</h1>
                    <button style={{ ...styles.tabButton, margin: '5px auto' }} className='download-btn-products'>Download Brochure</button>
                </header>

                <section style={styles.section} className='products-inner-section'>
                    <h2 style={styles.sectionTitle} className='overview-heading'>Overview</h2>
                    <p style={styles.paragraph} className='overview-paragraph'>
                        Quanto Retail ERP is a powerful, web-based solution designed to empower retailers with the tools they need to streamline operations, enhance customer experiences, and drive business growth. From managing inventory to optimizing sales, Quanto Retail ERP provides a unified platform that integrates all aspects of retail management.
                    </p>
                </section>
                <style>
                    {`
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(20px); scale(0.75) }
                        100% { opacity: 1; transform: translateY(0); scale(1.25) }
                    }
                    @keyframes grow2 {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.2); opacity: 0.6; color: black }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    @keyframes pulseGlow {
                        0% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                        50% {
                        transform: scale(1.1);
                        opacity: 0.8;
                        color: #ffc107;
                        text-shadow: 0 0 20px rgba(255, 193, 7, 0.7);
                        }
                        100% {
                        transform: scale(1);
                        opacity: 1;
                        color: #ff8c00;
                        text-shadow: 0 0 10px rgba(255, 140, 0, 0.5);
                        }
                    }
                    `}
                </style>
                <div style={styles.leftSection} className='products-tab-container'>
                    <h1 style={styles.title} className='products-section-title'>
                        {activeTab === "features" ? "Features" : "Benefits"}
                    </h1>
                    <div style={styles.tabContainer} >
                        <button
                            className='tab-btn-1'
                            style={{
                                ...styles.tabButton,
                                ...(activeTab === "features" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => setActiveTab("features")}
                        >
                            Features
                            <span style={styles.tabIcon}>
                                {activeTab === "features" ? "🟡" : "⚪"}
                            </span>
                        </button>
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(activeTab === "benefits" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => setActiveTab("benefits")}
                            className='tab-btn-2'
                        >
                            Benefits
                            <span style={styles.tabIcon}>
                                {activeTab === "benefits" ? "🟡" : "⚪"}
                            </span>
                        </button>
                    </div>
                </div>
                <div style={{ display: 'flex', width: "80%", alignSelf: 'center' }} className='points-container'>
                    <div>
                        <div style={styles.rightSection} className='products-right-section'>
                            <div style={styles.itemsContainer} className='products-right-inside-section'>
                                {items.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            ...styles.item,
                                            opacity: animateItems ? 0 : 1,
                                            animation: animateItems
                                                ? `fadeIn 0.5s ease-out ${index * 0.2}s forwards`
                                                : "none",
                                        }}
                                        className='check-points'
                                        onClick={() => handlePointClick(index)}
                                    >
                                        {/* <span style={styles.itemIcon}>⦿</span> */}
                                        <CheckCircleOutlineIcon style={styles.itemIcon} />
                                        <span style={styles.itemText} className='products-item-text'>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {selectedPoint !== null && (
                        <div style={styles.detailsSection} className='products-details-section'>
                            <h2 style={styles.detailsTitle} className='products-details-title'>{items[selectedPoint]}</h2>
                            <p style={styles.detailsText} className='products-details-description'>{details[selectedPoint]}</p>
                        </div>
                    )}
                </div>
                {/* <section style={styles.section}>
                    <h2 style={styles.sectionTitle}>Why Choose Quanto Retail ERP?</h2>
                    <p style={styles.paragraph}>
                        With Quanto Retail ERP, retailers can achieve operational excellence and superior customer experiences. Our solution is designed to integrate seamlessly with various retail functions, making it an essential tool for businesses looking to thrive in a competitive market and take your business to the next level!
                    </p>
                </section> */}
            </div>
            <Footer />
        </>
    );
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #000000 0%, #434343 100%)",
        color: "#fff",
        padding: "40px",
        borderRadius: "20px",
        position: "relative",
        overflow: "hidden",
        minHeight: "60vh",
        width: "95vw",
        margin: "20px auto",
    },
    leftSection: {
        flex: "1",
        paddingRight: "50px",
        marginBottom: "30px",
    },
    rightSection: {
        flex: "2",
        position: "relative",
        width: "45vw",
        alignSelf: "center",
        marginRight: '20px'
    },
    title: {
        fontSize: "3em",
        textAlign: "center",
        marginBottom: "20px",
    },
    tabContainer: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    },
    tabButton: {
        backgroundColor: "transparent",
        border: "2px solid #ff8c00",
        color: "#fff",
        fontWeight: 700,
        padding: "15px 30px",
        borderRadius: "35px",
        fontSize: "1.5em",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    activeTabButton: {
        backgroundColor: "#f39d3c",
        color: "#000",
    },
    tabIcon: {
        marginLeft: "10px",
        animation: "pulseGlow 4.5s ease-in-out 0.5s infinite",
    },
    itemsContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridTemplateRows: "repeat(4, 1fr)",
        gap: "20px",
        backgroundColor: "rgba(255, 140, 0, 0.8)",
        borderRadius: "20px",
        padding: "30px",
    },
    item: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        padding: "10px",
        borderRadius: "10px",
        transition: "background-color 0.3s ease",
    },
    itemIcon: {
        marginRight: "10px",
        fontSize: "30px",
        animation: "grow2 4.5s ease-in-out 0.5s infinite",
    },
    itemText: {
        fontSize: "1.5em",
        fontWeight: 600,
    },
    detailsSection: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        borderRadius: "20px",
        padding: "30px",
        animation: "fadeIn 0.5s ease-out",
        width: "70vw",
        boxSizing: "border-box",
    },
    detailsTitle: {
        fontSize: "2em",
        margin: 0,
        marginBottom: "15px",
        color: "#ff8c00",
        textAlign: 'center'
    },
    detailsText: {
        fontSize: "1.25em",
        lineHeight: "1.6",
        margin: 0,
    },

    header: {
        alignItems: 'center',
    },
    titleInfo: {
        fontSize: '2.75em',
        fontWeight: 700,
        color: '#fff',
        textAlign: "center",
        marginBottom: 60,
    },
    button: {
        backgroundColor: '#f6a608',
        color: 'white',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '30px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        letterSpacing: '1px',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        outline: 'none',
        margin: '20px auto',
        display: 'block',
    },
    section: {
        margin: '30px 0',
        width: "70vw",
        alignSelf: "center",
    },
    sectionTitle: {
        fontSize: '2em',
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: '20px',
    },
    paragraph: {
        fontSize: '1.35em',
        lineHeight: '1.6',
        color: '#ccc',
    },
};

